<template>
  <div :class="theme">
    <b-navbar
      toggleable="lg"
      type="dark"
      class="atmHeaderStyle py-4 px-0 pb-0 text-lg-right "
      sticky
    >
      <b-navbar-toggle class="m-1" target="sidebar-collapse">
        <span class="material-icons-round">menu</span>
      </b-navbar-toggle>
      <b-navbar-brand class="float-right notifications text-right p-0 pr-lg-4">
        <notifications-header-popup
          :isParent="userIsAParent"
          :childId="childId"
        ></notifications-header-popup>
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidebar-collapse" shadow lazy backdrop>
      <b-navbar-nav>
        <div
          v-for="(group, index) in items"
          :key="index"
          :class="{
            'mt-3': index === 0,
            'mb-3': index === items.length - 1,
          }"
        >
          <b-nav-item
            v-for="(item, idx) in group"
            v-bind:key="idx"
            v-if="item.title !== 'Theme'"
            @click="$router.push(`${item.router}`)"
            :disabled="item.enable === false"
          >
            <span
              class="material-icons-outlined align-middle ml-4 mr-2"
              :class="item.enable === false ? 'text-secondary' : 'color-secundary'"
              >{{ item.img }}</span
            >
            <span :class="item.enable === false ? 'text-secondary' : 'color-secundary'">{{
              item.title
            }}</span>
          </b-nav-item>
          <div v-else>
            <b-nav-item-dropdown id="theme" right class="ml-4">
              <template v-slot:button-content>
                <span class="material-icons align-middle mr-2"></span>
                <span class="color-secundary">{{ item.title }}</span>
              </template>
              <b-dropdown-item
                v-for="(palette, idx) in item.palette"
                :key="idx"
                class="d-inline-block"
                @click="changePalette(idx)"
              >
                <span class="material-icons big-icon" :class="`${palette.color}`">lens</span>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
          <hr v-if="index < items.length - 1" class="mx-3 my-2" />
        </div>
      </b-navbar-nav>
    </b-sidebar>
  </div>
</template>
<script>
import { getMenuItems, getThemeColor } from '@/common/utils';
import NotificationsHeaderPopup from '@/notifications/components/NotificationsHeaderPopup.vue';

export default {
  components: { NotificationsHeaderPopup },
  props: {
    userIsAParent: { type: Boolean, default: false },
    childId: { type: String, required: true },
    themeIndex: { type: Number, required: true },
  },
  data() {
    return { darkMode: false };
  },
  watch: {
    darkMode(newMode, oldMode) {
      this.darkModeChange(newMode);
    },
  },
  computed: {
    items() {
      return getMenuItems(this.userIsAParent);
    },
    theme() {
      return `bg-${getThemeColor(this.themeIndex)}`;
    },
  },
  methods: {
    logout() {
      this.logoutAction().then(() => {
        this.$router.push('/login');
      });
    },
    changePalette(colorIndex){
      this.$emit("changeTheme", colorIndex);
    }
  },
};
</script>
<style lang="scss">
.navbar-nav {
  background-color: white;
}

#theme .dropdown-toggle::after {
  color: #aaaaaa;
}
#theme .dropdown-menu {
  border: 0;
  background-color: #f2f2f2;
  padding: 1rem 0;
}

.atmHeaderStyle {
  border-radius: 26px;
}

.navbar-nav .nav-link {
  text-align: left !important;
}

.navbar-mobile {
  border-radius: 27px !important;
  margin-top: 17px;
}
/* @overrite */
.navbar-dark .navbar-toggler {
  border: none;
  color: white !important;
  :hover {
    border: none;
  }
}
.b-sidebar {
  background-color: white !important;
  border-radius: 0px 24px 24px 0;
  padding: 1.5rem 0;
  width: 100%;
  max-width: 300px;
  min-width: 200px;
}
</style>

